import request from "@/utils/request";

/**
 * 上传图片并压缩
 * @param {image, width, height} formData 
 * @returns 
 */
export function imageUpload(formData) {
  return request({
    url: "/tp/compression/image",
    baseURL: process.env.VUE_APP_IMAGE_UPLOAD,
    method: "post",
    headers: {
      "x-auth-token": process.env.VUE_APP_TOKEN,
      "Content-Type": "multipart/form-data",
    },
    data: formData
  })
}

/**
 * 上传视频音频
 * @param {file} formData 
 * @returns 
 */
export function mediaUpload(formData) {
  return request({
    url: "/tp/upload/video",
    baseURL: process.env.VUE_APP_IMAGE_UPLOAD,
    method: "post",
    headers: {
      "x-auth-token": process.env.VUE_APP_TOKEN,
      "Content-Type": "multipart/form-data",
    },
    data: formData
  })
}